import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/styles/index.css'
import VueScrollTo from 'vue-scrollto'
import SlideUpDown from 'vue-slide-up-down'

import 'font-awesome/css/font-awesome.min.css'

//defined as global component
Vue.component(
  'VueFontawesome',
  require('vue-fontawesome-icon/VueFontawesome.vue').default,
)

Vue.component('slide-up-down', SlideUpDown)

Vue.use(VueScrollTo, {
  offset: -50,
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
